import type { ReactNode } from "react";
import { APIProvider } from "@vis.gl/react-google-maps";
import { GOOGLE_MAPS_API_KEY, hasGoogleMaps } from "@/lib/locations/maps-config";


/**
 * Laster Google Maps (kart og Places) bare der lokasjonssidene trenger det.
 * Uten nøkkel (lokalt uten env) rendres barna uten Google, og stedssøk og
 * kart viser en enkel reserve.
 */
export function MapsProvider({ children }: { children: ReactNode }) {
  if (!hasGoogleMaps()) return <>{children}</>;
  return (
    <APIProvider apiKey={GOOGLE_MAPS_API_KEY} language="no" region="NO">
      {children}
    </APIProvider>
  );
}
